import { render, staticRenderFns } from "./RemoteMonitoringIndicatorsAdd.vue?vue&type=template&id=09e5af90"
import script from "./RemoteMonitoringIndicatorsAdd.vue?vue&type=script&lang=js"
export * from "./RemoteMonitoringIndicatorsAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports